import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { BetslipConfig, EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { PopupAction } from '@frontend/sports/modal/feature';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { ModelPopupTypes } from '@frontend/sports/navigation/core/feature/url-helper';
import { UserService } from '@frontend/sports/user/feature';
import { CashierService, ProductHomepagesConfig } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { PopupManager } from 'packages/sports/web/app/src/popup/popup-manager.service';

import DigitalActions from '../../digital/actions';
import { BaseBalanceHeaderComponent } from '../balance-header/base-balance-header.component';
import LinearBetslipTrackingActions from '../tracking/state/linear-tracking.actions';

@Component({
    selector: 'bs-digital-balance-header',
    templateUrl: './digital-balance-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./digital-balance-header.component.scss'],
    standalone: false,
})
export class DigitalBalanceHeaderComponent extends BaseBalanceHeaderComponent implements OnChanges {
    @Input() inColumn = false;

    @HostBinding('class.hidden') hidden = true;

    isCloseCtaTextEnabled = false;
    private modelSlideOutToBottom = 'modal-slide-out-to-bottom';
    showLoginButtonInHeader = false;

    constructor(
        private store: Store,
        public sitecore: Sitecore,
        private popupManager: PopupManager,
        private cashierService: CashierService,
        userService: UserService,
        epcotConfig: EpcotConfig,
        private betslipConfig: BetslipConfig,
        private redirectHelper: RedirectHelperService,
        private productHomepagesConfig: ProductHomepagesConfig,
    ) {
        super(userService, epcotConfig);

        this.isCloseCtaTextEnabled = this.betslipConfig.isCloseCtaTextEnabled;
        this.showLoginButtonInHeader = this.betslipConfig.showLoginButtonInHeader;
    }

    ngOnChanges(changes: ISimpleChanges<DigitalBalanceHeaderComponent>): void {
        if (changes.inColumn) {
            this.hidden = !this.betslipConfig.isBalanceHeaderEnabled || this.inColumn;
        }
    }

    get depositButtonClass(): string {
        return this.isEpcot ? 'btn btn-md btn-light' : 'btn btn-primary btn-sm';
    }

    get closeButtonClass(): string {
        return this.isEpcot ? 'btn btn-md btn-light' : 'btn btn-dark btn-sm';
    }

    get loginButtonClass(): string {
        return this.isEpcot ? 'btn btn-md btn-light login' : 'btn btn-dark btn-sm login';
    }

    get registerButtonClass(): string {
        return this.isEpcot ? 'btn btn-primary btn-md' : 'btn btn-dark btn-sm';
    }

    get showXCloseButton(): boolean {
        return !this.isCloseCtaTextEnabled;
    }

    close(): void {
        this.store.dispatch(LinearBetslipTrackingActions.clickBetslipCloseCta());
        this.store.dispatch(DigitalActions.closeBetslipTriggered());

        this.popupManager.dismissPreviousPopup(ModelPopupTypes.Betslip, PopupAction.ManualClose, this.modelSlideOutToBottom);
    }

    makeDeposit(): void {
        this.store.dispatch(LinearBetslipTrackingActions.clickBetslipDepositCta());

        this.cashierService.goToCashierDeposit({});
    }

    register(): void {
        this.redirectHelper.goToPage(this.productHomepagesConfig.portal + '/mobileportal/register');
    }

    login(): void {
        this.redirectHelper.goToLogin();
    }
}
